<template>
    <div class="prospective-patent-analysis-mics display-flex flex-column w-100 h-100">
        <AccordionPanel label="Ai Summary" id="family" type="ai-summary" :initially-expanded="true">
            <AonSkeleton
                class="w-100 display-flex align-items-center mb-sm flex-wrap"
                :loading="summaryLoading"
                :data="0"
                :height="'80px'"
                light
            >
                <div v-if="summary" class="statements mt-sm">
                    <div class="problems">
                        <p class="extra-small uppercase mb-sm bold">Problems</p>
                        <ul style="list-style: circle">
                            <li class="ml-xl mt-sm" v-for="item in summary?.problems">
                                <p class="small text-stone-700 m-sm d-inline">
                                    {{ item.description }}
                                </p>
                            </li>
                        </ul>
                    </div>
                    <div class="solutions">
                        <p class="extra-small uppercase mb-sm mt-xl bold">Potential Solutions</p>
                        <ul style="list-style: circle">
                            <li class="ml-xl mt-sm" v-for="item in summary?.solutions">
                                <p class="small text-stone-700 m-sm d-inline">
                                    {{ item.description }}
                                </p>
                            </li>
                        </ul>
                    </div>
                    <div class="benefits">
                        <p class="extra-small uppercase mb-sm mt-xl bold">Value</p>
                        <ul style="list-style: circle">
                            <li class="ml-xl mt-sm" v-for="item in summary?.benefits">
                                <p class="small text-stone-700 m-sm d-inline">
                                    {{ item.description }}
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </AonSkeleton>
        </AccordionPanel>
        <h6>Mapped Products</h6>
        <ProspectivePatentConceptsPatentFilingYears />
    </div>
</template>

<script setup>
import AccordionPanel from '@/components/helpers/AccordionPanel.vue'
import { computed, ref } from 'vue'
import { useProspectivePatentPlaybookStore } from '@/stores/prospectivePatentPlaybook.js'
import ProspectivePatentConceptsPatentFilingYears from '@/components/playbooks/playbookTypes/prospectivePatentAnalysis/charts/ProspectivePatentConceptsPatentFilingYears.vue'

const playbookStore = useProspectivePatentPlaybookStore()

const summaryLoading = computed(() => playbookStore.loadingStates?.micsAiSummary?.loading ?? true)
const summary = computed(() => playbookStore.aiSummary)
</script>

<style scoped lang="scss">
.prospective-patent-analysis-mics {
    gap: 20px;
}
</style>
